/* Omegasense product page behaviour. Works with the os-* sections. */
(function () {
  'use strict';

  var state = { plan: null, qty: 1, busy: false };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function root() { return $('[data-os-product]'); }

  /* ---------- gallery ---------- */
  function initGalleries() {
    $$('[data-gallery]').forEach(function (g) {
      if (g.__osReady) return;
      g.__osReady = true;
      var track = $('[data-track]', g);
      var slides = $$('[data-slide]', g);
      var thumbs = $$('[data-thumb]', g);
      var dots = $$('[data-dot]', g);
      if (!track || !slides.length) return;
      function mark(i) {
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          mark(i);
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) mark(Number(e.target.dataset.slide)); });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (s) { io.observe(s); });
      }
    });
  }

  /* ---------- dispatch message (UK time) ---------- */
  function initDispatch() {
    var r = root();
    if (!r) return;
    var cutoff = (Number(r.dataset.cutoff) || 14) * 60;
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
      }).formatToParts(new Date());
    } catch (e) { return; }
    function part(t) { return parts.find(function (p) { return p.type === t; }).value; }
    var day = part('weekday');
    var minsLeft = cutoff - (Number(part('hour')) * 60 + Number(part('minute')));
    var weekend = day === 'Sat' || day === 'Sun';
    var text;
    if (!weekend && minsLeft > 0) {
      var h = Math.floor(minsLeft / 60), m = minsLeft % 60;
      text = (r.dataset.dispatchToday || '').replace('[time]', (h > 0 ? h + ' h ' : '') + m + ' min');
    } else if (weekend || day === 'Fri') {
      text = r.dataset.dispatchMonday;
    } else {
      text = r.dataset.dispatchTomorrow;
    }
    if (text) $$('[data-dispatch]').forEach(function (el) { el.textContent = text; });
  }

  /* ---------- buy box state ---------- */
  function money(cents) {
    var r = root();
    var cur = (r && r.dataset.currency) || 'GBP';
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  }

  function unitPrice() {
    var r = root();
    var sub = Number(r.dataset.priceSub), once = Number(r.dataset.priceOnce);
    return state.plan === 'sub' && r.dataset.hasSub === 'true' ? sub : once;
  }

  function render() {
    var r = root();
    if (!r) return;
    var total = unitPrice() * state.qty;
    var free = Number(r.dataset.freeOver) || 0;
    var sold = r.dataset.available === 'false';
    $$('[data-cta-label]').forEach(function (el) {
      if (el.closest('[data-added]')) return;
      el.textContent = sold ? r.dataset.labelSoldOut : (r.dataset.labelAdd + ' · ' + money(total));
    });
    $$('[data-plan-summary]').forEach(function (el) {
      el.textContent = state.plan === 'sub' ? r.dataset.sumSub : r.dataset.sumOnce;
    });
    $$('[data-qty]').forEach(function (el) { el.value = String(state.qty); });
    $$('[data-delivery-nudge]').forEach(function (el) {
      var unlocked = free > 0 && total >= free;
      el.toggleAttribute('data-unlocked', unlocked);
      el.textContent = unlocked ? r.dataset.nudgeFree : r.dataset.nudgeMore;
    });
    var field = $('[data-os-plan-field]');
    if (field) field.disabled = state.plan !== 'sub';
  }

  function initBuyBox() {
    var r = root();
    if (!r) return;
    var checked = $('[data-plan-input]:checked');
    state.plan = checked ? checked.value : 'once';
    state.qty = Number(($('[data-qty]') || {}).value) || 1;
    render();
  }

  /* ---------- add to bag ---------- */
  function openCart() {
    var hasDrawer = !!$('cart-drawer-component');
    try {
      if (hasDrawer && typeof _EVENT_HELPER !== 'undefined' && _EVENT_HELPER.updateAndShowCart) {
        document.dispatchEvent(new CustomEvent(_EVENT_HELPER.updateAndShowCart));
        return;
      }
    } catch (e) { /* fall through to the cart page */ }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function addToBag(btn) {
    var r = root();
    if (!r || state.busy || r.dataset.available === 'false') return;
    state.busy = true;
    var item = { id: Number(r.dataset.variant), quantity: state.qty };
    if (state.plan === 'sub' && r.dataset.hasSub === 'true') item.selling_plan = Number(r.dataset.plan);
    var url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function () {
      var label = $('[data-cta-label]', btn);
      btn.setAttribute('data-added', '');
      if (label) label.textContent = r.dataset.labelAdded;
      var live = $('[data-live]');
      if (live) live.textContent = r.dataset.labelAdded + '.';
      openCart();
      window.setTimeout(function () { btn.removeAttribute('data-added'); render(); }, 1800);
    }).catch(function () {
      var form = $('[data-buy-form]');
      if (form) form.submit(); /* plain form post as a fallback */
    }).then(function () { state.busy = false; });
  }

  /* ---------- delegated events (survive theme-editor reloads) ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-plan-input]')) {
      state.plan = e.target.value;
      render();
    }
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest && e.target.closest('[data-qty-step]');
    if (step) {
      state.qty = Math.min(9, Math.max(1, state.qty + Number(step.dataset.qtyStep)));
      render();
      return;
    }
    var add = e.target.closest && e.target.closest('[data-add]');
    if (add && !add.closest('form')) addToBag(add);

    var batch = e.target.closest && e.target.closest('[data-batch]');
    if (batch) {
      var rec = batch.closest('[data-record]');
      var limits = { totox: Number(rec.dataset.totoxLimit), peroxide: Number(rec.dataset.peroxideLimit) };
      $$('[data-batch]', rec).forEach(function (b) { b.setAttribute('aria-pressed', String(b === batch)); });
      [['totox', 1], ['peroxide', 2]].forEach(function (k) {
        var v = Number(batch.dataset[k[0]]);
        $('[data-' + k[0] + '-value]', rec).textContent = v.toFixed(k[1]);
        $('[data-' + k[0] + '-fill]', rec).style.width = Math.max(v / limits[k[0]] * 100, 2).toFixed(1) + '%';
      });
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('[data-buy-form]')) {
      e.preventDefault();
      addToBag($('[data-hero-cta]', form) || $('[data-add]', form));
    }
  });

  /* ---------- sticky bar ---------- */
  function initSticky() {
    var bar = $('[data-sticky]'), hero = $('[data-hero-cta]'), fin = $('[data-final-cta]');
    if (!bar || !hero || bar.__osReady || !('IntersectionObserver' in window)) return;
    bar.__osReady = true;
    var seen = new Map();
    var targets = [hero].concat(fin ? [fin] : []);
    function update() {
      if (seen.size < targets.length) return;
      var show = targets.every(function (t) { return !seen.get(t); });
      bar.toggleAttribute('data-visible', show);
      bar.toggleAttribute('inert', !show);
      bar.setAttribute('aria-hidden', String(!show));
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
      update();
    });
    targets.forEach(function (t) { io.observe(t); });
  }

  function init() {
    initGalleries();
    initBuyBox();
    initDispatch();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();